<template>
  <b-overlay
    id="overlay-background"
    :show="historyLoader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-card
      :class="customChange ? 'list-group-item custom-curser' : 'custom-curser'"
    >
      <b-card-header
        class="case-logs-history-header"
      >
        <b-card-title>{{ $t('DEBTIA_CASE_LOGS_HISTORY') }}</b-card-title>
        <b-card-title class="text-primary">
        <!-- <drag-links
          :parent="8"
          :side="side"
          :custom-change="customChange"
        /> -->
        </b-card-title>
      </b-card-header>
      <b-alert
        v-if="errorMessage"
        variant="warning"
        show
      >
        <div class="alert-body">
          {{ errorMessage }}
        </div>
      </b-alert>
      <!-- search here -->
      <b-form-group>
        <b-input-group>
          <b-form-input
            id="search"
            v-model="searchQuery"
            :placeholder="$t('DEBTIA_SEARCH')"
            @keyup.enter="searchQuery.length <= 3 ? filterHistory() : ''"
            @input="searchQuery.length > 3 ? filterHistory() : ''"
          />
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              :class="filter_active ? 'filter-active' : ''"
              @click="filter_active = !filter_active"
            >
              <feather-icon
                icon="FilterIcon"
              />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-checkbox-group
          v-if="filter_active"
          v-model="selectedFilters"
          :options="filtersOptions"
          class="mt-1 filter-btns d-flex flex-wrap gap-1"
          name="buttons-1"
          size="sm"
          buttons
          button-variant="outline-primary"
        />
      </b-form-group>
      <div
        v-if="caseLogsData.length > 0"
        class="scroll-div"
      >
        <div
          v-for="(data,cldindex) in caseLogsData"
          :key="cldindex"
          class="mt-2"
        >
          <div
            v-if="data.type === 'note'"
          >
            <b-card
              v-if="canshow(data.case_log_roles)"
              class="border mb-0"
            >
              <b-card-text class="card-text content-heading mb-35">
                <h4>
                  {{ $t('DEBTIA_DEBT_CASE_NOTES') }}
                </h4>
                <p>
                  {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }},  {{ $t('DEBTIA_CREATED_BY') + " " + data.employee_name }}
                </p>
              </b-card-text>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <label
                      class="note-font"
                      v-html="data.note"
                    />
                    <b-badge variant="light-primary">
                      <b-button
                        :id="'notes-popover-reactive-'+data.id"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="btn-icon"
                      >
                        <feather-icon icon="EyeIcon" />
                      </b-button>
                      <b-button
                        v-if="checkOtherDeletionScenario($ability.can(constants.action.permissionDeleteDebtCaseNote, constants.resource.user), data)"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="btn-icon ml-1"
                        @click="confirmAndRemove(data.id)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                      <b-popover
                        ref="popover"
                        :target="'notes-popover-reactive-'+data.id"
                        triggers="hover"
                        placement="auto"
                        container="my-container"
                      >
                        <template #title>
                          <div class="d-flex justify-content-between align-items-center">
                            <span>{{ $t('DEBTIA_ALLOWED_ROLES') }}</span>
                          </div>
                        </template>
                        <div>
                          <b-card
                            border-variant="primary"
                            bg-variant="transparent"
                            class="shadow-none"
                          >
                            <b-card-text v-if="data.case_log_roles.length > 0">
                              <h6
                                v-for="(role ,roleindex) in data.case_log_roles"
                                :key="roleindex"
                              >&#8226; {{ getTitle(role.role_id) }} </h6>
                            </b-card-text>
                          </b-card>
                        </div>
                      </b-popover>
                    </b-badge>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            v-else-if="data.type === 'email'"
          >
            <b-card
              class="border mb-0"
            >
              <div class="d-flex justify-content-between">
                <div>
                  <h4>Debtia Email: {{ data.title }}</h4>
                  <p>
                    {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                  </p>
                </div>
                <feather-icon
                  v-if="data.case_email_logs.email_events.length"
                  icon="InfoIcon"
                  size="20"
                  class="cursor-pointer"
                  @click="OpenEmailLogsMOdal(data)"
                />
              </div>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <label
                      class="note-font"
                    >From: <a :href="'mailto:' + data.case_email_logs.sender">{{ data.case_email_logs.sender }}</a></label>
                  </div>
                </div>
              </div>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <label
                      class="note-font"
                    >To: <a :href="'mailto:' + data.case_email_logs.receiver">{{ getReceiver(data.case_email_logs.receiver) }}</a></label>
                  </div>
                </div>
              </div>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <label
                      class="note-font"
                    >Subject: {{ data.case_email_logs.subject }}</label>
                  </div>
                </div>
              </div>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div
                    style="overflow-y: hidden"
                  >
                    <label
                      class="note-font"
                      v-html="(data.isOpen === true) ? data.case_email_logs.body : data.case_email_logs.body.substr(0, 150)"
                    />
                    <b-button
                      v-if="data.case_email_logs.body.length > 150 && data.isOpen === false"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      class="edit-client-btn"
                      @click="setStrLimit(data.id, 'more')"
                    >
                      {{ $t("DEBTIA_VIEW_MORE") }}
                      <feather-icon
                        icon="ChevronDownIcon"
                      />
                    </b-button>
                    <b-button
                      v-if="data.case_email_logs.body.length > 150 && data.isOpen === true"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      class="edit-client-btn"
                      @click="setStrLimit(data.id, 'less')"
                    >
                      {{ $t("DEBTIA_VIEW_LESS") }}
                      <feather-icon
                        icon="ChevronUpIcon"
                      />
                    </b-button>
                  </div>
                </div>
              </div>
              <div
                v-if="data.attachments != null && data.attachments.length > 0 && data.attachments !== '[]'"
                class="border mb-10 padding-content"
              >
                <div
                  class="business-item"
                >
                  <div
                    class="d-flex flex-column"
                  >
                    <b-link
                      v-for="(value, index) in JSON.parse(data.attachments)"
                      :key="index"
                      :href="value"
                      target="_blank"
                      :class="{'mt-75': index}"
                    >
                      <span class="text-muted font-weight-bolder align-text-top">{{ value.substring(value.lastIndexOf("/")+1) }} <feather-icon
                        icon="ExternalLinkIcon"
                      /></span>
                    </b-link>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            v-else-if="data.type === 'case_creation_info'"
          >
            <b-card
              class="border mb-0"
            >
              <b-card-text class="card-text content-heading mb-35">
                <h4>
                  {{ data.title }}
                </h4> <p>
                  {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                </p>
              </b-card-text>
              <div
                id="collapse-1-inner"
                class="mt-2 content-container"
              >
                <div class="border mb-10 padding-content">
                  <div
                    id="history-content"
                    class="note-content-div"
                    v-html="decodeNote(data.note)"
                  />
                </div>
              </div>
            </b-card>
          </div>
          <div
            v-else-if="data.type === 'letter'"
          >
            <b-card
              class="border mb-0"
            >
              <b-card-text class="card-text content-heading">
                <div style="float: right">
                  <p>
                    {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                  </p>
                  <feather-icon
                    v-if="data.case_letter_logs.email_events.length"
                    icon="InfoIcon"
                    size="20"
                    class="cursor-pointer"
                    style="float: right;"
                    @click="openLettersLog(data)"
                  />
                </div>
              </b-card-text>
              <b-card-text class="card-text content-heading">
                <h4>Debtia Letter: {{ data.title }}</h4>
                <p>
                  <b-link
                    class="mt-75"
                  >
                    <feather-icon icon="MailIcon" /> {{ $t('DEBTIA_DISPATCHED') }} </b-link> : {{ data.sent_at }}
                </p>
                <b-link
                  v-if="data.case_letter_logs"
                  :href="getLink(data.case_letter_logs.attachments)"
                  target="_blank"
                  class="mt-75"
                ><span class="text-muted font-weight-bolder align-text-top">{{ getLink(data.case_letter_logs.attachments).substring(getLink(data.case_letter_logs.attachments).lastIndexOf("/")+1) }} <feather-icon
                  icon="ExternalLinkIcon"
                /></span>
                </b-link>
                <div>
                  <b-badge
                    v-if="data.case_letter_logs.email_status"
                    variant="success"
                  >
                    Email
                  </b-badge>
                  <b-badge
                    v-if="data.case_letter_logs.print_status"
                    variant="warning"
                    style="margin: 4px;"
                  >
                    Print
                  </b-badge>
                </div>
              </b-card-text>
            </b-card>
          </div>
          <div
            v-else-if="data.type === 'process'"
          >
            <b-card
              class="border mb-0"
            >
              <b-card-text class="card-text content-heading mb-35">
                <h4>
                  {{ data.title }}
                </h4> <p>
                  {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                </p>
              </b-card-text>
              <div
                v-if="data.note "
                id="collapse-1-inner"
                class="mt-2 content-container"
              >
                <div class="border mb-10 padding-content">
                  <div
                    id="history-content"
                    class="note-content-div file-path"
                  >
                    <label
                      class="note-font"
                      v-html="parseStr(data.note)"
                    />
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            v-else-if="data.type === 'edit_statement' || data.type === 'delete_file' || data.type === 'edit_variable' || data.type === 'pause_case' || data.type === 'update_interest_rate'"
          >
            <b-card
              class="border mb-0"
            >
              <b-card-text class="card-text content-heading mb-35">
                <h4>
                  {{ data.title }}
                </h4> <p>
                  {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                </p>
              </b-card-text>
              <div
                v-if="data.note "
                id="collapse-1-inner"
                class="mt-2 content-container"
              >
                <div class="border mb-10 padding-content">
                  <div
                    id="history-content"
                    class="note-content-div"
                  >
                    <label
                      class="note-font"
                      v-html="data.note"
                    />
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            v-else-if="data.type === 'sms'"
          >
            <b-card
              class="border mb-0"
            >
              <h4>Debtia Sms: {{ data.title }}</h4>
              <p>
                {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
              </p>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <label
                      class="note-font"
                    >To: {{ data.case_sms_logs.receiver }}</label>
                  </div>
                </div>
              </div>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div
                    style="overflow-y: hidden"
                  >
                    <div
                      style="width: 100%; max-width: 100%; overflow: hidden; white-space: pre-line; word-wrap: break-word; line-height: 25px"
                      v-html="detectAndLinkifyText(data.case_sms_logs.body)"
                    />
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            v-else
          >
            <b-card
              class="border mb-0"
            >
              <b-card-text class="card-text content-heading mb-35">
                <h4>
                  {{ data.title }}
                </h4> <p>
                  {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                </p>
              </b-card-text>
              <div
                id="collapse-1-inner"
                class="mt-2 content-container"
              >
                <div class="border mb-10 padding-content">
                  <div
                    id="history-content"
                    class="note-content-div"
                  >
                    {{ printTextWithoutTags(data.note) }}
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
      <div
        v-else
      >
        There are no records found.
      </div>
    </b-card>
    <logs-history-modal
      ref="logsModalRef"
      :case-logs-data="storeCaseLogsData"
    />
  </b-overlay>
</template>

<script>
import {
  // BRow, BCol,
  BCard, BFormGroup, BButton, BInputGroup, BFormInput, BInputGroupAppend, BCardText, BPopover, BBadge, BCardHeader, BCardTitle, BOverlay, BLink, BAlert, BFormCheckboxGroup,
  // BPagination,
} from 'bootstrap-vue'
// import store from '@/store'
// import router from '@/router'
// import { ref, reactive } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import constants from '@/app-configs/constants'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import i18n from '@/libs/i18n'
import LogsHistoryModal from './LogsHistoryModal.vue'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    // BRow,
    // BCol,
    BCard,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BCardText,
    BPopover,
    BFormCheckboxGroup,
    BBadge,
    BCardHeader,
    BCardTitle,
    BOverlay,
    BLink,
    BAlert,
    LogsHistoryModal,
    // DragLinks,
    // BPagination,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      historyLoader: true,
      storeCaseLogsData: [],
      notestext: '',
      showNotesAlert: false,
      searchQuery: '',
      caseLogsData: [],
      userRoles: [],
      user_role: JSON.parse(localStorage.getItem('userData')).role[0],
      loggedIn_userID: JSON.parse(localStorage.getItem('userData')).data.id,
      errorMessage: '',
      filter_active: true,
      selectedFilters: ['note', 'email', 'letter', 'process', 'sms'],
      filtersOptions: [
        { text: 'Notes', value: 'note' },
        { text: 'Emails', value: 'email' },
        { text: 'Letters', value: 'letter' },
        { text: 'Processes', value: 'process' },
        { text: 'SMS', value: 'sms' },
        { text: 'General', value: 'general' },
      ],
    }
  },
  computed: {
  },
  watch: {
    filter_active: {
      handler() {
        if (!this.filter_active) {
          this.selectedFilters = ['note', 'email', 'letter', 'process', 'sms']
          this.getHistory()
        }
      },
    },
    selectedFilters: {
      handler() {
        this.filterHistory()
      },
    },
    searchQuery: {
      handler() {
        if ((this.filter_active && this.selectedFilters.length !== 0) && this.searchQuery.length === 0) {
          this.filterHistory()
        }
        if (!(this.filter_active && this.selectedFilters.length !== 0) && this.searchQuery.length === 0) {
          this.getHistory()
        }
      },
    },
  },
  created() {
    EventBus.$on('refreshLogs', () => {
      if (this.filter_active) {
        this.filterHistory()
      } else {
        this.getHistory()
      }
    })
    EventBus.$on('setUserRoles', data => {
      this.setUserRolesMethod(data)
    })
  },
  methods: {
    async fetchInitialData() {
      await this.filterHistory()
    },
    detectAndLinkifyText(text) {
      return text.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank">$1</a>',
      )
    },
    checkOtherDeletionScenario(permission, data) {
      let result = false
      if (permission) {
        result = true
      }
      if (!permission && (data.user_id === this.loggedIn_userID && this.dateTimeWithinADay(data.created_at))) {
        result = true
      }
      return result
    },
    dateTimeWithinADay(dateStr) {
      // Create a Date object from the given date string
      const givenDate = new Date(dateStr)

      // Get the current date and time
      const currentDate = new Date()

      // Calculate the difference in milliseconds
      const diffInMs = currentDate - givenDate

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60)

      // Check if the difference is less than 24 hours
      return diffInHours < 24
    },
    confirmAndRemove(id) {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: i18n.t('DEBTIA_DELETE_CONFIRMATION_MSG'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteNote(id)
        }
      })
    },
    async deleteNote(id) {
      this.historyLoader = true
      const url = `${constants.baseUrlV2}/delete-debt-case-logs/${id}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.historyLoader = false
          this.getHistory()
        }
      }).catch(error => {
        this.historyLoader = false
        this.errorMessage = error.response.data.message
      })
    },
    formatString(str) {
      const formattedText = str
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      return formattedText
    },
    parseStr(content) {
      try {
        const obj = typeof content === 'string' ? JSON.parse(content) : content

        if (!obj || typeof obj !== 'object') return content

        const isEn = this.$i18n.locale === 'en'
        const localizedHelperKeys = new Set([
          'en_dated_at',
          'da_dated_at',
          'en_execution_date',
          'da_execution_date',
        ])

        const skipKeys = new Set(['dated', 'time'])
        const keyMap = {
          dated_at: ['en_dated_at', 'da_dated_at'],
          execution_date: ['en_execution_date', 'da_execution_date'],
        }
        const parts = []
        Object.keys(obj).forEach(key => {
          if (skipKeys.has(key) || localizedHelperKeys.has(key)) return

          let value = obj[key]

          if (keyMap[key]) {
            const localizedKey = isEn ? keyMap[key][0] : keyMap[key][1]
            value = obj[localizedKey] || obj[key]
          }
          if (!value) return

          parts.push(`<strong>${this.formatString(key)}</strong>: ${value}`)
        })
        return parts.join('<br>')
      } catch (e) {
        return content
      }
    },
    setUserRolesMethod(data) {
      this.userRoles = data
    },
    getLink(attachments) {
      const att = JSON.parse(attachments)
      return att[0]
    },
    decodeNote(text) {
      const vrs = JSON.parse(text)
      let note = `<p class='mb-0'><strong>Created By:</strong> ${vrs.created_by}</p>`
      if (vrs.integration_used) {
        note += `<p class='mb-0'><strong>Integration Used:</strong> ${vrs.integration_used}</p>`
      }
      if (vrs.public_token) {
        note += `<p class='mb-0'><strong>Case created with external API with Public Token:</strong> ${vrs.public_token}</p>`
      }
      note += `<p class='mb-0'><strong>Created At:</strong> ${this.formatDate(vrs.created_at)}</p>`
      return note
    },
    formatDate(dateStr) {
      const date = new Date(dateStr.replace(' ', 'T'))

      const day = date.getDate()
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      const monthName = date.toLocaleString('en-US', { month: 'long' })

      return `${day}. ${monthName}, ${year} at ${hours}:${minutes}`
    },
    printTextWithoutTags(text) {
      const textWithoutTags = text.replace(/<[^>]*>/g, '')
      return textWithoutTags
    },
    async setStrLimit(id, action) {
      if (action === 'more') {
        if (this.caseLogsData.length > 0) {
          this.caseLogsData.forEach((element, index) => {
            if (element.id === id) {
              this.caseLogsData[index].isOpen = true
            }
          })
        }
      }
      if (action === 'less') {
        if (this.caseLogsData.length > 0) {
          this.caseLogsData.forEach((element, index) => {
            if (element.id === id) {
              this.caseLogsData[index].isOpen = false
            }
          })
        }
      }
    },
    async getHistory() {
      this.historyLoader = true
      const caseID = this.$route.params.id
      const url = `${constants.baseUrlV2}/debt-case/logs-data/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.historyLoader = false
          this.caseLogsData = response.data.data
        }
      })
    },
    getTitle(role) {
      const entry = this.userRoles.filter(record => record.value === role)
      let title = 'N/A'
      if (entry[0]) {
        title = entry[0].label
      }
      return title
    },
    UppercaseTransformation(str) {
      return str.split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    getLoggedInRoleId() {
      const entry = this.userRoles.filter(record => this.UppercaseTransformation(record.name) === this.UppercaseTransformation(this.user_role))
      let id = 0
      if (entry[0]) {
        id = entry[0].value
      }
      return id
    },
    canshow(contents) {
      let exists = false
      const loggedInRoleId = this.getLoggedInRoleId()
      const entry = contents.filter(record => record.role_id === loggedInRoleId)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
    getReceiver(str) {
      const att = JSON.parse(str)
      return att.to
    },
    OpenEmailLogsMOdal(data) {
      this.storeCaseLogsData = [data]
      this.$nextTick(() => {
        this.$refs.logsModalRef.show()
      })
    },
    openLettersLog(data) {
      this.storeCaseLogsData = [data]
      this.$nextTick(() => {
        this.$refs.logsModalRef.show()
      })
    },
    async filterHistory() {
      if (this.filter_active && this.selectedFilters.length === 0) {
        this.caseLogsData = []
      }
      if (this.searchQuery.length > 0 || (this.filter_active && this.selectedFilters.length > 0)) {
        this.historyLoader = true
        const caseID = this.$route.params.id
        const filters = this.filter_active ? this.selectedFilters : []
        const url = `${constants.baseUrlV2}/debt-case/logs-data/${caseID}?search=${this.searchQuery}&filters=${filters}`
        await axios.get(url).then(response => {
          if (response.status === 200) {
            this.historyLoader = false
            this.caseLogsData = response.data.data
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
.note-content-div {
  display: inline-block; width: 93%; min-height: 38px;
}

.file-path {
  overflow-x: auto;
  white-space: nowrap;
}

.content-heading {
  margin-bottom: 0px !important;
}

.custom-curser {
  cursor: default;
}

.scroll-div {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 600px;
  padding-right: 10px;
}

.scroll-div::-webkit-scrollbar {
    width: 12px;
}

.scroll-div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}

.filter-active {
  background-color: #b9c3c2 !important;
}

.marginleft-18 {
  margin-left: -18px;
}

.filter-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  justify-content: center;  /* centers horizontally */
  align-items: center;      /* optional: aligns vertically */
}

.filter-btns > .btn {
  border-radius: 0px !important;
}

.btn-group-toggle [class*=btn-outline-]:not(:last-child) {
  border-right-width: 1px !important;
}
</style>
